// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605141111/js/" + chunkId + "." + {"44":"3610c154","225":"6f36b7a0","481":"5a4f71a3","486":"9ee8fb6c","770":"3be66ef2"}[chunkId] + ".0.4073686522321207.chunk.js";
};